"use client";

import React from "react";
import { Download, Crosshair, Zap, Maximize2, Layers, Palette } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheMasterPrinterHub() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const specs = [{
    icon: <Palette className="w-6 h-6 text-primary" />,
    title: "12-Color LUCIA PRO II Ink",
    desc: "Achieve the deepest blacks and richest colors with our advanced pigment ink system designed for gallery-quality prints."
  }, {
    icon: <Maximize2 className="w-6 h-6 text-primary" />,
    title: "60-inch Wide Printing",
    desc: "Massive scale capabilities for panoramic landscapes, life-size portraits, and industrial signage."
  }, {
    icon: <Layers className="w-6 h-6 text-primary" />,
    title: "Archival Quality",
    desc: "Prints designed to last a lifetime with superior lightfastness and scratch resistance."
  }, {
    icon: <Zap className="w-6 h-6 text-primary" />,
    title: "High-Speed Processing",
    desc: "L-COA PRO image processing engine ensures high-precision data handling for complex files."
  }];
  const hotspots = [{
    top: "35%",
    left: "25%",
    label: "Ink System",
    detail: "12-Channel Integrated Compact Print Head"
  }, {
    top: "45%",
    left: "65%",
    label: "Media Handling",
    detail: "Intelligent automatic roll feeding & multi-function roll system"
  }, {
    top: "65%",
    left: "40%",
    label: "Output",
    detail: "High-precision mechanical platform for vibration-free printing"
  }];
  return null;
}